/*eslint-disable*/
import React from "react";

// reactstrap components
import { Button, Container, Row, Col, Link } from "reactstrap";

import logoFooter from "../../assets/img/logo-footer.png";

// core components

function FooterBlackSocial() {
  return (
    <>
      <footer className="footer footer-arhock" data-background-color="black">
        <Container>
          <div className="content">
            <Row>
              <Col md="4"></Col>
              <Col md="4 text-center">
                <img src={logoFooter} className="footer-logo mb-2" />
                {/* <h6>Dirección</h6>
                <ul className="links-vertical">
                  <li>46 #943 e/ 13 y 14</li>
                </ul> */}
                <h6 className="mt-3">Seguinos</h6>
                <a href="https://www.facebook.com/AsociacionRioplatensedeHockey" target="_blank">
                  <i className="fab fa-facebook-square fa-lg social-link mr-2 clickable"></i>
                </a>
                <a href="https://www.instagram.com/a.r.hock" target="_blank">
                  <i className="fab fa-instagram fa-lg social-link"></i>
                </a>
                <h6 className="mt-2">Escribinos</h6>
                <a href="mailto:asociacionrioplatensedehockey@gmail.com" target="_blank">
                  <i className="far fa-envelope social-link mr-2"></i>
                  asociacionrioplatensedehockey@gmail.com
                </a>{" "}
              </Col>
              <Col md="4"></Col>
            </Row>
          </div>
          <hr></hr>
          <div className="copyright" id="copyright">
            © 2026 Brainworks
          </div>
        </Container>
      </footer>
    </>
  );
}

export default FooterBlackSocial;
